import T from "@Tilesets/sewer/tiles.jsx";
// Map
export default [
  ...[
    T.EMPTY,
    T.EMPTY,
    T.EMPTY,
    T.EMPTY,
    T.EMPTY,
    T.EMPTY,
    T.EMPTY,
    T.EMPTY,
    T.EMPTY,
    T.EMPTY,
    T.EMPTY,
    T.EMPTY,
    T.EMPTY,
    T.EMPTY,
    T.EMPTY,
    T.EMPTY,
    T.EMPTY,
  ],
  ...[
    T.EMPTY,
    T.EMPTY,
    T.NLW_CORNER,
    T.N_WALL,
    T.N_WALL,
    T.N_WALL,
    T.N_WALL,
    T.N_WALL,
    T.N_WALL,
    T.N_WALL,
    T.N_WALL,
    T.N_WALL,
    T.N_WALL,
    T.N_WALL,
    T.NRW_CORNER,
    T.EMPTY,
    T.EMPTY,
  ],
  ...[
    T.EMPTY,
    T.NLW_CORNER,
    T.NLW_COLUMN,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.NRW_COLUMN,
    T.NRW_CORNER,
    T.EMPTY,
  ],
  ...[
    T.EMPTY,
    T.L_WALL,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.R_WALL,
    T.EMPTY,
  ],
  ...[
    T.EMPTY,
    T.L_WALL,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.R_WALL,
    T.EMPTY,
  ],
  ...[
    T.EMPTY,
    T.L_WALL,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.R_WALL,
    T.EMPTY,
  ],
  ...[
    T.EMPTY,
    T.L_WALL,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.R_WALL,
    T.EMPTY,
  ],
  ...[
    T.EMPTY,
    T.L_WALL,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.R_WALL,
    T.EMPTY,
  ],
  ...[
    T.EMPTY,
    T.L_WALL,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.R_WALL,
    T.EMPTY,
  ],
  ...[
    T.EMPTY,
    T.L_WALL,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.R_WALL,
    T.EMPTY,
  ],
  ...[
    T.EMPTY,
    T.L_WALL,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.R_WALL,
    T.EMPTY,
  ],
  ...[
    T.EMPTY,
    T.L_WALL,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.R_WALL,
    T.EMPTY,
  ],
  ...[
    T.EMPTY,
    T.L_WALL,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.R_WALL,
    T.EMPTY,
  ],
  ...[
    T.EMPTY,
    T.L_WALL,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.R_WALL,
    T.EMPTY,
  ],
  ...[
    T.EMPTY,
    T.L_WALL,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.R_WALL,
    T.EMPTY,
  ],
  ...[
    T.EMPTY,
    T.L_WALL,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.R_WALL,
    T.EMPTY,
  ],
  ...[
    T.EMPTY,
    T.SLW_CORNER,
    T.SLW_COLUMN,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.SRW_COLUMN,
    T.SRW_CORNER,
    T.EMPTY,
  ],
  ...[
    T.EMPTY,
    T.EMPTY,
    T.SLW_CORNER,
    T.S_WALL,
    T.S_WALL,
    T.S_WALL,
    T.S_WALL,
    T.S_WALL,
    T.S_WALL,
    T.S_WALL,
    T.S_WALL,
    T.S_WALL,
    T.S_WALL,
    T.S_WALL,
    T.SRW_CORNER,
    T.EMPTY,
    T.EMPTY,
  ],
  ...[
    T.EMPTY,
    T.EMPTY,
    T.EMPTY,
    T.EMPTY,
    T.EMPTY,
    T.EMPTY,
    T.EMPTY,
    T.EMPTY,
    T.EMPTY,
    T.EMPTY,
    T.EMPTY,
    T.EMPTY,
    T.EMPTY,
    T.EMPTY,
    T.EMPTY,
    T.EMPTY,
    T.EMPTY,
  ],
];
